/**
 * Filter view store for Employees Portfolio page.
 */

import { employeesConfig } from './employees.config';
import { createFilterViewStore } from '@/stores/filterViewUtils/createFilterViewStore';

export const useEmployeesFilterViewStore = createFilterViewStore(
  employeesConfig.pageIdentifier,
  false, // Filter panel closed by default
);
